module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "untitled-1"
    }
  }, [_c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "heading-2-361-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override31"
  }, [_c('br', {
    staticClass: "calibre1"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "normal"
  }, [_c('br', {
    staticClass: "calibre1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "chapter",
    attrs: {
      "id": "toc-anchor-4"
    }
  }, [_vm._v("FOUR")]), _vm._v(" "), _c('p', {
    staticClass: "chapter1"
  }, [_vm._v("Some Gentle Persuasion ")]), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("We hadn’t seen Leonard in at least three weeks. We’d been busy since our return from Ireland, including taking a quick trip back to Limerick to check out our new-to-us estate, which we’d acquired in Don Vincenzo’s overly generous will. ")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("Of course, the combustible bodyguard no doubt had his own fish to fry.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("Besides, hanging around with me isn’t on Leonard’s Top Ten Things to Do Today list, nor is it on his Top 100 list, either. To say that we don’t always get along is a bit of an understatement, although I’ll offer that I am fonder of him, and especially of his skills in a tight situation, than he is of me in any capacity. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("He looked a hell of a lot better than he had when we’d talked briefly with him at the winery while spending the day with Don Fredo, a couple of days after our return from Mutton Island. For starters, the sunken, sallow look in his face was gone, along with the sling protecting his shoulder after the gunshot he’d sustained in our defense.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("Elmore had told us that his partner was taking better care of himself of late, and it showed.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Looking good, Leonard,” I said when we saw the pair approach our table, on the 30")]), _c('span', {
    staticClass: "no-style-override32"
  }, [_vm._v("th")]), _c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v(" floor of one of the city’s downtown bank buildings, where the Portland City Grill is located.")])])]), _vm._v(" "), _c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Up yours, Blake. And don’t call me Leonard,” he snapped, scowling at me the whole time, his lips twisted into a noteworthy sneer.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Glad to see we can pick things up again without skipping a beat,” I said, doing my best to smile while shaking hands with Elmore, who is Leonard’s exact opposite in temperament. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("But Leonard wasn’t done.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“That scar on your face isn’t going away anytime soon, is it?” he said. “Doesn’t do you any favors in the looks department.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("I ignored the remark about my scar, a result of being struck by shrapnel during the assault on Mutton Island, and remained silent, striving for what I hoped was an amiable grin. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("But Leonard wasn’t smiling, and he appeared to be ready to light into me again when Caeli interrupted.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“It’s wonderful to see you looking so well, Leonard,” she said easily, rising from her seat and pulling him close for a gentle hug. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("He was clearly uncomfortable. But he kept his mouth shut and allowed the embrace, though his participation was anything but relaxed. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("Caeli broke the hug but held both of his hands and smiled radiantly at him.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Anyone who didn’t know better would be hard-pressed to learn that you were wounded in the line of duty,” she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“I damn well know it, though,” he mumbled softly, shifting his eyes to the floor as he spoke, doing his best to subtly shake free of her hands. But his face softened with her soothing words, and he nodded shyly at Caeli and whispered what I thought was a “Nice to see you” – or at least its equivalent.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("Caeli is as adept at soothing Leonard’s inner beast as I am at activating it. She continued to smile at him – brightly, genuinely – and he returned it with a look that I’d best describe as belonging to a little boy who, lost on the streets of the big city and forced to ask for help, simply wasn’t accustomed to accepting the kindness of strangers but was happy enough to obtain some.")])])]), _vm._v(" "), _c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("I knew enough to remain in the shadows as Caeli pressed the conversation. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("Even Elmore stayed quiet, and Elmore likes to talk … especially to Caeli and me.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“How long have you been out of the sling?” she asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“A little more than a week,” he said, flexing his arm instinctively. “Feels pretty good. Most of the pain’s gone, and much of the mobility’s back. Doc Strand says I’ll be good as new in a couple’a months if I keep working at it. He’s got me doing some rehab stuff.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("I was tempted to say something here, a smart-ass line that would fire him up again. “You weren’t all that good to begin with” sprang to mind. But Caeli must have sensed it and beat me to the opening. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“That’s wonderful, Leonard,” she said. “You had us all worried for a minute – for more than a minute, really.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Yeah, well, it’s all good now, I guess,” he said, and he pulled free from her grasp and folded his hands in front of his belt buckle in an awkward motion, an indication that he wasn’t quite certain how he should react to all of this attention. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("Caeli beamed brightly at him as she patted his good shoulder, then gave Elmore a quick hug and returned to her seat, which provided the rest of us with a license to sit.   ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("I winked at her, an acknowledgement that she’d been able to effectively defuse Leonard’s pre-planned ambush with little more than a smile and a few soft words.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("But Leonard was only temporarily sidetracked.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“So Blake, did you bring more than one credit card?” he asked.")])])]), _vm._v(" "), _c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“I did, Leonard,” I said, ignoring his grimace at the use of my pet nickname. “I brought an American Express card, plus a Visa and a MasterCard – three in all. We should be able to cover the tab, I’d say.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Don’t be too sure,” he said. “I figure you owe me – big-time.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Agreed. I do owe you. And I’m happy to pay, my friend.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Yeah, right,” he said, with the scowl front and center. “I wanna hear all about it – every last detail about how happy you really are. I’m anxious, for instance, to figure out how much you’re willing to pay to engage us for this latest …”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("He stopped abruptly, searching for the right word to skewer me anew, his eyebrows knitted in pensive thought. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Adventure?” I tried.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Hell no. That won’t cover it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Caper?” I suggested.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“What the hell is a caper?”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Well, it’s an adventure,” I said. “You can add an adjective to it, if you like.”  ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("He looked puzzled.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Adjective? What the hell are you talking about now?”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“It’s a word that modifies a noun, in the same way that adverbs modify verbs,” I said. “Had grammarians been on the ball, back in the day, they would have called them adnouns instead of adjectives.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("He looked on blankly before seeking additional clarification.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Now you’re really off in La-La Land, Blake. Gimme a for-instance.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Sure. Crazy, maybe – a crazy caper. Or Nutty. Or whacky, perhaps.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Zany works. So does daft,” Caeli offered.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Batshit,” Elmore said, then caught himself and turned a nice shade of pink and mumbled a brief apology.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("We all took our cue from Caeli, who merely smiled at Elmore’s enthusiastic slip.")])])]), _vm._v(" "), _c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Yeah, I get it,” Leonard said at last. “But that don’t do it for me. A batshit adventure, or a batshit caper, still implies some sort of, I don’t know, fun time for all. And with you two – or at least with you, Blake – fun don’t cover it. Not in my book, anyway.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“So what did you have in mind?” I asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“About what, exactly?”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“About a name for whatever comes next, about a price to put on the adventure, or caper … about anything your heart desires,” I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“I don’t know. Let me think about it,” he replied. “But I don’t want to talk about it – about any of this … this whatever it is – until I’ve eaten. I’ve been working up a hell of an appetite.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Sure thing, Leonard. Have at it,” I said and waved to get the attention of one of the servers.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Don’t call me Leonard, god dammit,” he muttered.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("A waiter showed up a moment later, a senior citizen with long sideburns and wispy gray hair that stuck out in sprigs on his mostly bald head. He was sporting a soul patch, an earring with a gold loop that looked more dime store than jeweler, and he had a three-days-old growth on his face that, had he chosen to add a bandanna rakishly set atop his forehead, would have given him a certain pirate quality, though not nearly as striking as, say, Johnny Depp’s Captain Jack Sparrow – or even Robert Newton’s clownish Long John Silver.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("As it was, he could have served as a model for the bumper stickers that proclaim Portland to be the weird capitol of the known universe.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("He introduced himself as Marvin from Maupin, gave us a rundown on the nightly specials, and took our drink orders. Caeli and I requested a bottle of Fierro Estates merlot, a bargain at $85, while Elmore sampled a Black Butte Porter on draft and Leonard inquired about the most expensive drinks on the menu and ended up with a bottle of 2008 Terrazas Cheval des Andes Malbec blend from Argentina for $161.")])])]), _vm._v(" "), _c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“You gonna drink that bottle by yourself?” Elmore asked once Marvin scurried off. “ ’Cause I’m not gonna help you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Didn’t ask you to. Just so you know” – and he grinned at me when he added this part – “I’m not gonna drink it at all,” Leonard said. “Think I’ll take it with me and sell it on eBay.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("I could only shake my head, subtly, of course, and was happy that I’d heeded Elmore’s warning and brought along a couple of credit cards.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("With Leonard barking out questions while shooting eye-daggers my way, we ended up with four orders of seared rare yellowfin tuna and three additional orders of oven-roasted crab cakes for appetizers, along with soup (Northwest cioppino) and salads – and we aren’t talking about the simple mixed greens variety, either. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("While Elmore was sensible, and Caeli and I have grown accustomed to smaller dinners for smaller appetites, Leonard eventually ordered two 10-ounce filet mignon steaks, medium, at $55 apiece, and two herb-slathered, butter-roasted 12-ounce lobster tails at $41 a pop, along with a variety of other scattered add-ons.  ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("But I’ll give him this: He at least sampled everything, the appetizers and other forerunners as well as the double main course, and he damn near finished off his various plates, leaving only the lobsters’ carapace and a couple of tiny pieces of steak behind.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“What’s wrong with those?” Elmore asked long minutes later, pointing with a butter knife at the remaining bites of filet and a half-eaten piece of bread.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Saving room for dessert,” Leonard said. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("Ignoring both business and the obligatory small talk, he asked for two varieties when the time came – the flourless valhrona chocolate torte and the roasted pineapple and coconut tart – and he polished them both off in short order, patting his stomach in satisfaction as he stretched out in his chair, taking in the striking views of the city and sunset on the western flank of distant Mount Hood for perhaps the first time since we’d sat down.")])])]), _vm._v(" "), _c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“I got hooked on Irish cream when we were over there,” he said a moment later. “Wonder if they have some on the menu.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“If they don’t, I’ll run out and buy you a bottle,” I said. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“I’ll hold you to that, Blake,” he said, and I had no doubt that he would.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("But Marvin from Maupin magically produced some Bailey’s and four appropriate Irish crystal glasses, and we toasted to Leonard’s appetite.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“You’re gonna get sick,” Elmore whispered.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Like hell I am,” he said. “I’d be sick if I had to pay for all this” – he spread his arms wide, grinning, even though most of the plates had been cleared away. “But with Blake footing the tab, I gotta say I’m feeling damn good about things.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“I’m happy to hear it,” I said. “So what do you say to talking a little business?”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“And spoil the mood?”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Anyway you want to play it, Leonard.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“And I told you not to call me that stupid name.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Sure,” I said. “But after I pick up the check for that meal, I’ll have earned the right to call you most any name I please, Leonard included.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("He pointed a finger my way, but Caeli again stepped in to unruffled his feathers.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Tell me, if you would, what Don Fredo mentioned after Max called,” she asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Not much,” Elmore said, stepping in while Leonard nicely covered a belch with his hand, turning his head to the side in an easy motion. “Only that you wanted us for a trip to Rome on what amounted to your time, not company time.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Did he say anything else, or provide any details?”")])])]), _vm._v(" "), _c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“No,” Leonard said. “The boss told us it was up to us if we wanted to go or not. He wasn’t going to order us to do it, which was nice. I miss Don Vincenzo, you know – I think of him damn near every day – but Fredo’s a good guy, easy to work for.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("The implication, I think, was that Vinny would have told them both to accompany us, leaving no room for disagreement.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("Caeli sipped the Bailey’s, no doubt trying to determine the best way to provide an assessment of our situation, taking a moment to think it through. I could relate. It was a lot to take in, and what had happened to us in Ireland replayed again in my mind. Try as I might to shut it out, Mutton Island was like an old black-and-white newsreel that ran non-stop in my head.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("Even closing my eyes didn’t help.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override16"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("’m not sure how much time passed, exactly. A few lengthy seconds is a good bet, though I’m open to the idea that it was minutes and not seconds at all. But Caeli eventually stepped back in to take the lead, seeing as how it was her uncle, her rescue mission, and mostly her idea. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Here’s what we know so far,” she said, and she slowly ran her index finger around the rim of the Bailey’s glass, her face somber and thoughtful. “We all saw my Uncle Jack die on Mutton Island. We were there, we heard the shots, we watched him go down in the rocks, we saw his body afterward … from a distance, anyway.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Sorry again for your loss, Caeli,” Elmore said softly. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“And I appreciate that greatly,” she said. “But now we’ve come to learn – and there’s no way to dance around it – that we all were deceived. Uncle Jack is alive, you see, and he’s in Rome right now, at the Vatican. That’s why we need to go there.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("Elmore, at least, looked shocked, though he said nothing as his jaw hung a couple of inches lower than it normally rests. His eyes jumped back and forth from Caeli, who sat silently and unmoving, to me, perhaps looking for confirmation about what he’d just heard, and then back to Caeli again.")])])]), _vm._v(" "), _c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("Leonard cocked his head slightly to the side, as though he thought that Caeli was pulling his leg. His eyes were gleaming orbs in the fading sunlight that streamed through the windows near our table, and I could tell that he was intrigued as to what might have taken place and – perhaps most of all – how it all slipped past him. It also was clear that he was troubled by the news, and I did my best to dispel the mental gymnastics – for both of them. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“No way you would’ve known, or figured it out,” I said. “They schlepped it by all of us, and we’d already put you guys through a hell of a lot at that stage.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“It’s my job to know,” Leonard grumbled.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Mine, too, and I didn’t see it,” Elmore said.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“None of us saw it,” Caeli said. “I’m not even sure Uncle Jack knew what was taking place out there.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Explain,” Leonard said. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“I can’t,” she said. “I wish it were otherwise, but right now we have no idea what happened, exactly, or why. All we know for sure is Jack is alive and in Vatican City. I have my suspicions about some of this. But that’s all they are: suspicions.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“And you want to confirm your suspicions by finding out what happened to your uncle … and why,” Elmore said. “Mostly why, right?”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“That’s it, exactly – plus figuring out what to do next … once we find him,” she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“So why us?” Leonard asked. “Seems like a pretty simple time of it. You get on the plane, you fly to Rome, you hire a taxi, you go to the Vatican, you find your uncle, you ask him what the hell is going on, and then you take off for home once you’ve cuffed him upside the head a few times for being a dipshit. Doesn’t sound like a situation that requires our help.”  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("Caeli smiled then, her Cheshire cat grin.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v(" “That would be nice, all right, if it played out that way,” she said. “But my take – no, our take – is that Jack is being held against his will, with the church responsible for his … abduction, for lack of a better word.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Abduction is a strong word,” Leonard said.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Do you like kidnapping any better?” she asked. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“I’m still trying to wrap my head around caper,” he muttered.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“So what’s this really all about?” Elmore asked. “Why would the church fake your uncle’s death, kidnap him off that island, haul him back to Rome, and keep him under wraps? That doesn’t make sense.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Agreed – wish I knew,” she said. “And to answer Leonard’s question, I think the Italians must be in on it. My guess is they were paid by the church, or at least by someone inside the church, to intervene on the island and get Jack out of the way before the Irish authorities could sweep him up.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“You mean the Italians who work – who worked – for Don Vincenzo?” Elmore asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Yes. Penn and Teller and company. One and the same.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“I don’t buy it,” Leonard said. “The don brought them in personally, to help you. It wasn’t the church.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Yes, well, I can’t prove it, of course. But even so, that’s what I’m thinking,” Caeli countered. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Why?” Leonard pressed. “To shut him up?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Yes. Exactly.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Then why not just let him die, if that’s all they wanted?” Leonard said. “Why bother with all the cloak and dagger? A dead guy’s gonna let fewer cats out of the bag than a live guy who’s held hostage or captive or … whatever. Why go to that extreme?”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Good questions – ones we’ll have to put to Uncle Jack when we see him again,” she said. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“I’m still lost,” Elmore said. “If your uncle was kidnapped, and if he’s being held at the Vatican, how did you guys even find out about it?”")])])]), _vm._v(" "), _c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“The same way I knew Uncle Jack was in trouble the first time,” she said. “He sent a postcard.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("They both stared at her for a long moment.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“As I remember it, Caeli, your uncle didn’t send that postcard,” Elmore said. “We found out it was sent by that Monsignor McBride guy, right?”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“You sound like your new boss,” she said. “Fredo told us the exact same thing.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“So what did you tell him?”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“That it’s exactly why we needed your help in sorting it out,” she said. “I didn’t trust the Italians when we were in Ireland – even if the two of you did, and likely still do. And I don’t trust the church when it comes to protecting its good name. Certain clergy have shown through the ages that they’ll do almost anything to, I don’t know, look good in the eyes of the world, I guess.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“From what I know, that ‘almost anything’ you mention wouldn’t prevent an occasional murder,” Leonard said. “Which is why I keep returning to this: Why keep your uncle alive? Why not just let him die on that island, as the thing went down, and be done with it?”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v(" Caeli studied Leonard for a time, thinking the situation through, before finally abandoning his eyes for a corner of the room above our heads. The conversation was difficult for her – no question. I did my best to help.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Maybe he knows something,” I said. “Maybe they’ve kept him alive because he has valuable information that somebody higher up the food chain needs for … whatever reason. Maybe it’s as simple as that.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Maybe,” Caeli said. “But one thing is clear: I intend to find out, whatever it is, and make peace with this thing, one way or another. Until a couple of days ago, my last thoughts of Uncle Jack were of him lying on the rocks near the Italians, clutching an AK-47, with at least two bullet holes in him. How they pulled this off – who knows? But I have every intention of finding out … of asking anybody else who had a hand in this, regardless of title or where they work, or even who they work for.”")])])]), _vm._v(" "), _c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Including your uncle?” Leonard asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Starting with my uncle,” she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“How about the pope?”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("Leonard said it facetiously. But Caeli didn’t take it that way.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Him, too.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("We were silent for a moment, each of us considering what we’d seen on Mutton Island weeks before and the implications, no doubt, of what might lie ahead.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“I’m in – again,” Elmore said after a few seconds passed. “I want to know what’s going on, and why.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Thank you, Elmore,” Caeli said. “Be sure to bring the satellite phones we used the last time, in Ireland.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("He nodded enthusiastically and would have jumped off a cliff for her at that point. Caeli can do that to you.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("She turned her attention to Leonard and smiled at him. I knew that smile as well. Hell, I’d follow her to the ends of the earth for one of those smiles. But Leonard is Leonard, and nothing is ever easy where he’s concerned.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“How about you, Leonard?” she asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("He looked to me instead.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“How much you gonna pay me, Blake?” he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“How much do you want?”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“I don’t know yet,” he said. “I’m not even sure you’ve got enough money between the two of you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("Elmore started to interrupt, but Leonard wagged a finger at him and stood.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Let me think on it. Last time I played nursemaid to you two, I damn near died – my arm still ain’t right.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“That’s fine,” Caeli said. “Just be quick about it. I’d like to get moving right away – as soon as we can make the arrangements.”")])])]), _vm._v(" "), _c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Arrangements we’ve already started on,” I added.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("Leonard nodded his head up and down a couple of times, then grabbed his unopened Argentinian wine bottle and started for the exit without another word, or even a backward glance.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("Elmore stood as well.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Whatever happens with him, I’m still in,” he said. “You can count on me. You can always count on me. And Professor B … thanks for dinner. From both of us.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("He smiled for a moment, almost shyly, and then he, too, was gone. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“So what do you think?” I said once Elmore’s big frame cleared the room. I waved for the waiter at the same time, mentally adding up the bill in my head and wondering whether the exercise was worth the price of a steep admission.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“If I had to guess, I’d say that Leonard is intrigued,” she said. “Whether it’s because he wants some revenge for getting shot, or to figure out the involvement of the Italians on Mutton Island, or the fact that he was duped about Uncle Jack’s death along with the rest of us, or the idea that Elmore is going to go regardless, I think he wants in … even if he plays like he doesn’t.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("I nodded my agreement, and my eyes grew wide when I glanced at the tab, which Marvin from Maupin set down with a smug glance that suggested the expectation of a fat tip. But Caeli just laughed when she saw my reaction.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“Hand it over, Max,” she said, reaching for the bill. “It’s my treat – worth every penny.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("“You might change your mind when you see it,” I said. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("But Caeli pulled the plastic out of her purse without so much as a glance and told Marvin to add 25 percent to the tab.  ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("At least our aging hippie waiter left with a smile that night.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "calibre_pb_36"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9846692","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Chapter_004.vue
// module id = 96
// module chunks = 0